import { initializeAnalytics, logEvent, setUserId, isSupported } from 'firebase/analytics';
import { getApp } from 'firebase/app';

let analyticsInstance = null;
let initializePromise = null;

async function getAnalyticsInstance() {
  if (analyticsInstance) return analyticsInstance;
  if (process.env.REACT_APP_USE_EMULATORS === 'true') return null;
  // initializeAnalytics throws if called twice for the same app, so concurrent
  // callers must share a single in-flight initialization.
  if (initializePromise) return initializePromise;

  initializePromise = (async () => {
    const supported = await isSupported();
    if (!supported) return null;

    // usePageTracking sends page_view manually; gtag's default auto page_view
    // on load would double-count every fresh visit.
    analyticsInstance = initializeAnalytics(getApp(), {
      config: { send_page_view: false },
    });
    return analyticsInstance;
  })();

  return initializePromise;
}

// Initialize eagerly (non-blocking)
getAnalyticsInstance();

export function setAnalyticsUserId(userId) {
  getAnalyticsInstance().then((analytics) => {
    if (analytics) setUserId(analytics, userId);
  });
}

export function trackEvent(eventName, params = {}) {
  if (process.env.REACT_APP_USE_EMULATORS === 'true') {
    // eslint-disable-next-line no-console
    console.debug('[analytics]', eventName, params);
    return;
  }
  getAnalyticsInstance().then((analytics) => {
    if (analytics) logEvent(analytics, eventName, params);
  });
}

export function trackPageView(pagePath, pageTitle) {
  trackEvent('page_view', { page_path: pagePath, page_title: pageTitle });
}
